export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/CarLite.d580e262.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};